// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts,import_extension=none"
// @generated from file documents/v3alpha/access_control.proto (package com.seed.documents.v3alpha, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Capability, CreateCapabilityRequest, GetCapabilityRequest, ListCapabilitiesForDelegateRequest, ListCapabilitiesRequest, ListCapabilitiesResponse } from "./access_control_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Access Control service provides management API for issuing and revoking Capabilities.
 *
 * @generated from service com.seed.documents.v3alpha.AccessControl
 */
export const AccessControl = {
  typeName: "com.seed.documents.v3alpha.AccessControl",
  methods: {
    /**
     * Lists existing capabilities.
     *
     * @generated from rpc com.seed.documents.v3alpha.AccessControl.ListCapabilities
     */
    listCapabilities: {
      name: "ListCapabilities",
      I: ListCapabilitiesRequest,
      O: ListCapabilitiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * List capabilities for a specific delegate.
     *
     * @generated from rpc com.seed.documents.v3alpha.AccessControl.ListCapabilitiesForDelegate
     */
    listCapabilitiesForDelegate: {
      name: "ListCapabilitiesForDelegate",
      I: ListCapabilitiesForDelegateRequest,
      O: ListCapabilitiesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a new capability.
     *
     * @generated from rpc com.seed.documents.v3alpha.AccessControl.CreateCapability
     */
    createCapability: {
      name: "CreateCapability",
      I: CreateCapabilityRequest,
      O: Capability,
      kind: MethodKind.Unary,
    },
    /**
     * Get a single capability by ID.
     *
     * @generated from rpc com.seed.documents.v3alpha.AccessControl.GetCapability
     */
    getCapability: {
      name: "GetCapability",
      I: GetCapabilityRequest,
      O: Capability,
      kind: MethodKind.Unary,
    },
  }
} as const;

